import { Furniture } from './../entities/Furniture';
import { Cabinet } from '../entities/Cabinet';
import { cabinetNameRules } from './nameGeneratorRules';
import nameGeneratorData from './nameGeneratorData.json';

function getCabinetNameNotTranslated(cabinet: Cabinet): string {
  for (const cabinetNameRule of cabinetNameRules) {
    if (cabinetNameRule.apply(cabinet)) return cabinetNameRule.name;
  }

  return 'Cabinet';
}

export function getCabinetNameWithoutDimensions(
  cabinet: Cabinet,
  language: string = 'en',
): string {
  const cabinetNameEnglish = getCabinetNameNotTranslated(cabinet);

  const translations = nameGeneratorData as any;
  if (language in translations && cabinetNameEnglish in translations[language])
    return translations[language][cabinetNameEnglish];

  return cabinetNameEnglish;
}

export function getFurnitureNameWithoutDimensions(
  furniture: Furniture,
  language: string = 'en',
): string {
  if (furniture.cabinets.length === 1)
    return getCabinetNameWithoutDimensions(
      furniture.cabinets[0].cabinet,
      language,
    );

  const cabinetNameEnglish = 'Furniture';

  const translations = nameGeneratorData as any;
  if (language in translations && cabinetNameEnglish in translations[language])
    return translations[language][cabinetNameEnglish];

  return cabinetNameEnglish;
}

export function getCabinetName(
  cabinet: Cabinet,
  language: string = 'en',
): string {
  return (
    getCabinetNameWithoutDimensions(cabinet, language) +
    ' (' +
    cabinet.height / 10 +
    'x' +
    cabinet.width / 10 +
    'x' +
    cabinet.depth / 10 +
    ' cm)'
  );
}

export function getFurnitureName(
  furniture: Furniture,
  language: string = 'en',
): string {
  return (
    getFurnitureNameWithoutDimensions(furniture, language) +
    ' (' +
    furniture.height / 10 +
    'x' +
    furniture.width / 10 +
    'x' +
    furniture.depth / 10 +
    ' cm)'
  );
}

export function getCabinetNames(cabinet: Cabinet): { [id: string]: string } {
  let cabinetNames: { [id: string]: string } = {};

  const translations = nameGeneratorData as any;
  for (const language in translations)
    cabinetNames[language] = getCabinetName(cabinet, language);

  cabinetNames['en'] = getCabinetName(cabinet, 'en');

  return cabinetNames;
}

export function getFurnitureNames(
  furniture: Furniture,
): { [id: string]: string } {
  let cabinetNames: { [id: string]: string } = {};

  const translations = nameGeneratorData as any;
  for (const language in translations)
    cabinetNames[language] = getFurnitureName(furniture, language);

  cabinetNames['en'] = getFurnitureName(furniture, 'en');

  return cabinetNames;
}
